import React  from 'react';
import PropTypes from 'prop-types';

import { Span } from '@ubisend/pulse-components';

const NBSP = '\u00A0';

const WarningMessageBody = ({ contentHeader, contentBody = "", warningText = "" }) => {
  const showAfterHeaderSpace = !!(contentBody || warningText);
  const showBetweenBodyWarningSpace = !!(contentBody && warningText);

  return (
    <Span>
      <Span bold>{contentHeader}</Span>
      {showAfterHeaderSpace && <br />}
      <Span italic>
        {contentBody}
        {showBetweenBodyWarningSpace && NBSP}
        {warningText && (
          <Span fat colour="danger">
            {warningText}
          </Span>
        )}
      </Span>
    </Span>
  );
};

WarningMessageBody.propTypes = {
  contentHeader: PropTypes.string.isRequired,
  contentBody: PropTypes.string,
  warningText: PropTypes.string,
};

export default WarningMessageBody;